import React from "react";
import { useParams } from "react-router-dom";
import { Navbar } from "../core/Navbar";
import { BottomNav } from "../core/BottomNav";

function Tandc() {
  const { type } = useParams();

  const htmlMap = {
    terms: "/Terms & Conditions.html",
    privacy: "/Privacy Policy.html",
  };

  const src = htmlMap[type] || "/Terms & Conditions.html";

  return (
    <div style={{overflow:"hidden"}}>
      <Navbar />
      <div style={{ marginTop: "60px" }}>
        <iframe
          style={{
            border: "none",
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "65px",
          }}
          src={src}
          title="Policy Page"
        ></iframe>
      </div>
      <BottomNav />
    </div>
  );
}

export default Tandc;
